import { render, staticRenderFns } from "./a-breadcrumbs.vue?vue&type=template&id=61a6c52c&"
import script from "./a-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./a-breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports